import React, { useRef, useState } from 'react'
import NumberInput, { INumberInputProps } from '../../common/NumberInput';
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store';
import LeoAiOverlay from '../../common/LeoAiOverlay';
import { FundItem } from '../../../models/Fund';
import { Utilities } from '../../../utility/utils';
import { useTranslation } from 'react-i18next';
import { Box, ITheme, Tooltip, Typography, useTheme } from '@mui/material';

interface IFundAllocationItemProps extends INumberInputProps {
    fund: FundItem;
}

const FundAllocationItem: React.FunctionComponent<IFundAllocationItemProps> = ({ fund, placeholder, value, onChange, style, disableMask, backgroundColor }) => {
    const ref = useRef<HTMLDivElement>(null);
    const [showToolTip, setShowToolTip] = useState(false);
    const portfolio = useAppSelector(state => state.createPortfolio.portfolio);
    const active = portfolio.retailInvestors;
    const maxProportion = Utilities.getFundMaxProportion(portfolio.fundraisingTarget, fund);
    const { t } = useTranslation();
    const theme = useTheme() as ITheme;
    const [showAllocationError, setShowAllocationError] = useState(false);
    const dispatch = useAppDispatch();

    const displayAllocationError = () => {
        setShowAllocationError(true);
        setTimeout(() => {
            setShowAllocationError(false);
        }, 5000)
    }

    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, number?: number | undefined): void => {
        let correctedNumber = number;
        if (active && correctedNumber !== undefined && correctedNumber > maxProportion * 100) {
            correctedNumber = maxProportion * 100
            displayAllocationError();
        }
        if (onChange)
            onChange(event, correctedNumber);
    }

    const focusIn = () => {
        if (!active) {
            return;
        }
        setShowToolTip(true);
    }
    const focusOut = () => {
        if (!active) {
            return;
        }
        setShowToolTip(false);
    }
    return (
        <div ref={ref}>
            <NumberInput placeholder={placeholder} value={value && value > 0 ? value : undefined} onChange={onChangeHandler} style={{...style, border: showAllocationError ? `2px solid ${theme.palette.leo.semantic.red}` : fund.eltif ? `2px solid ${theme.palette.primary.dark}` : undefined}} disableMask={disableMask} onFocus={focusIn} onBlur={focusOut} smallFormat backgroundColor={backgroundColor} />
            {showToolTip && <LeoAiOverlay target={ref} placement='left-start' alignItems='flex-end' padding='0 20px' maxWidth={"289px"} undismissable={true}>
                <p>{t('CreatePortfolioAiAssistantProportion1')}</p>
                {maxProportion >= 1 ?
                    <p>{t('CreatePortfolioAiAssistantProportion2')} {fund.name} {t('CreatePortfolioAiAssistantProportion3')}</p>
                    :
                    <p>{t('CreatePortfolioAiAssistantProportion2')} {fund.name} {t('CreatePortfolioAiAssistantProportion3bis')} {(maxProportion * 100).toFixed(1)}%</p>
                }
            </LeoAiOverlay>}
            <Tooltip
                PopperProps={{
                    disablePortal: true,
                }}
                componentsProps={{
                    arrow: {
                        style: {
                            color: theme.palette.leo.color2
                        }
                    },
                    tooltip: {
                        style: {
                            backgroundColor: theme.palette.leo.color2
                        }
                    }
                }}
                open={showAllocationError}
                placement='bottom-end'
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={
                    <Box display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} padding={"12px"} gap={"12px"}>
                        <Typography fontWeight={700} fontSize={"12px"} lineHeight={"18px"} color={theme.palette.common.white}>{t('CreatePortfolioIncorrectAllocationTitle')}</Typography>
                        <Typography fontWeight={500} fontSize={"12px"} lineHeight={"18px"} color={theme.palette.common.white}>{t('CreatePortfolioIncorrectAllocationText')}</Typography>
                    </Box>}
                arrow={true}>
                <div></div>
            </Tooltip>
        </div>
    )
}

export default FundAllocationItem;